//Importar el enrutador
import AppRoutes from "./router/AppRouter";

const App = () => {
  return (
    <AppRoutes />
  );
}

export default App;
